<template>
  <PageBase title="Algemene introductie programma van eisen" description="" :valid="valid" :show-right-button="false" class="xl:mr-15">
    <div class="flex flex-col gap-4 text-justify">

      <div class="text-sm">Welkom op de online omgeving voor het genereren van een generiek Programma van Eisen (PvE) voor onderwijshuisvesting. Deze tool is ontwikkeld door het Programma Onderwijshuisvesting (POHV).</div>
      <div class="text-sm">Het PvE is samengesteld op basis van actuele beleidsdocumenten, normeringen, wet- en regelgeving en rekenmethodieken. Al deze bronnen zijn zorgvuldig geïntegreerd in één centrale database, met een integrale benadering als uitgangspunt.</div>
      <div class="text-sm">U wordt straks stap voor stap gevraagd om informatie in te voeren over uw specifieke opgave en keuzes te maken binnen enkele ambitie-thema's. Op basis van uw invoer selecteert het systeem automatisch de bijpassende eisen uit de database, zodat een op maat gemaakt PvE-document ontstaat dat aansluit op uw specifieke opgave.</div>
      <div class="text-sm">Op de laatste pagina krijgt u een overzicht van uw keuzes en kunt u uw e-mailadres invullen. Vervolgens ontvangt u binnen enkele minuten het gegenereerde document in uw inbox.</div>
      <div class="text-sm">Veel succes en bedankt voor uw bijdrage aan toekomstbestendige onderwijshuisvesting!</div>

    </div>

    <BlueButton mode="text" text="Start" css="w-40 text-center !bg-green-700 mt-6" :class="!valid && '!opacity-60 !hover:opacity-60 !cursor-default'" @click="start" />

  </PageBase>
</template>

<script setup lang="ts">
import PageBase from '@/views/pages/PageBase.vue';
import BlueButton from '@/components/BlueButton.vue';

import { ref } from 'vue';

const emit = defineEmits(['start'])
const valid = ref(true)

function start() {
  emit('start')
}
</script>
